import { Component, OnInit, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { TermsOrGdprResource } from 'app/models/TermsOrGdprResource';
import { UtilsService } from 'app/services/utils.service';
import { forkJoin } from 'rxjs';
import { KioskListResource } from 'app/models/KioskListResource';
import { KioskComponent } from 'app/kiosk/kiosk.component';
import { KioskResource } from 'app/models/KioskResource';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { TermsOrGdprAndKioskResource } from 'app/models/TermsOrGdprAndKioskResource';
import { ContactDetailsResource } from 'app/models/ContactDetailsResource';

@Component({
	selector: 'vbn-add-edit-text-content',
	templateUrl: './add-edit-text-content.component.html',
	styleUrls: ['./add-edit-text-content.component.scss']
})
export class AddEditTextContentComponent implements OnInit {

	addressParams: any;
	terms = true;
	userEmail: string;
	saveErrors: boolean = false;
	text: TermsOrGdprResource
	gdpr: TermsOrGdprResource;
	selected_language: string;
	errorMessage: any;
	showDelete: boolean = false;
	kiosksList: KioskListResource;
	filterCriteria: FilterCriteriaListEdt;
	checkList: any;
	checkObject: any;
	kioskListResource: KioskResource[];
	arrayToSend: any;
	isContact: boolean = false;
	contact: ContactDetailsResource;

	constructor(private activatedRoute: ActivatedRoute,
		private utilsService: UtilsService,
		private translate: TranslateService,
		private _notificationService: NotificationsService,
		private router: Router,
		private fb: FormBuilder,
		private element: ElementRef) {

		this.selected_language = "ro";
		this.text = new TermsOrGdprResource();
		this.gdpr = new TermsOrGdprResource();
		this.kiosksList = new KioskListResource();
		this.kiosksList.list = new Array<KioskResource>();
		this.filterCriteria = new FilterCriteriaListEdt();
		this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
		this.checkList = new Array();
		this.kioskListResource = new Array();
		this.arrayToSend = new Array();
		this.contact = new ContactDetailsResource();
	}

	ngOnInit() {
		this.userEmail = this.utilsService.currentUserEmail;
		this.getKioskList();
		this.activatedRoute.params.subscribe((params: Params) => {
			if ('terms' in params) {
				this.addressParams = JSON.parse(atob(params['terms']));
				//this.terms = (this.addressParams.terms === 'true') ? true : false;
				if (this.addressParams.terms == 0) {
					this.terms = true;
				} else if (this.addressParams.terms == 1) {
					this.terms = false;
				} else if (this.addressParams.terms == 2) {
					this.isContact = true;
				}
				if (this.isContact) {
					this.getByUserContactDetails(this.userEmail);
				} else {
					this.getByUser(this.userEmail, this.terms);
				}

			}
		});

	}

	getKioskList() {
		this.utilsService.add('/admin/kiosk/getAll?userEmail=' + this.userEmail, this.filterCriteria)
			.subscribe(
				response => {
					this.kiosksList = response;
					if (this.kiosksList.errorCode == 1002) {
						forkJoin(
							[this.translate.get('Error'),
							this.translate.get('0 items found after the search!')]
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'error')
						});
						this.kiosksList = new KioskListResource();
						this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
						this.kiosksList.list = [];
					}
					this.initializationKioskList();
				},
				error => this.errorMessage = <any>error);
	}

	initializationKioskList() {
		if (this.kiosksList.list == null) {
			this.kioskListResource = []
		} else {
			this.kioskListResource = this.kiosksList.list;
		}
		this.checkList = new Array();
		if(this.isContact) {
			for (let i = 0; i < this.kiosksList.list.length; i++) {
				this.checkObject = {};
				this.checkObject = new KioskResource();
				this.checkObject = this.kiosksList.list[i];
				this.checkList.push(this.checkObject);
			}
		} else {
			for (let i = 0; i < this.kiosksList.list.length; i++) {
				this.checkObject = {};
				this.checkObject.kiosk = new TermsOrGdprAndKioskResource();
				this.checkObject.kiosk = this.kiosksList.list[i];
				this.checkList.push(this.checkObject);
			}
		}
		this.checkObject = {};
	}

	updateCheckedOptions(kiosk, event) {
		if (event.target.checked) {
			if (this.isContact) {
				let contactKiosk = new KioskResource()
				contactKiosk = kiosk;
				this.arrayToSend.push(contactKiosk);
			} else {
				let termsOrGdpr = new TermsOrGdprAndKioskResource()
				termsOrGdpr.kiosk = kiosk;
				this.arrayToSend.push(termsOrGdpr);
			}

		} else {
			for (let i = 0; i < this.arrayToSend.length; i++) {
				if(this.isContact) {
					if (kiosk.rid == this.arrayToSend[i].rid) {
						this.arrayToSend.splice(i, 1);
						return
					}
				} else {
					if (kiosk.rid == this.arrayToSend[i].kiosk.rid) {
						this.arrayToSend.splice(i, 1);
						return
					}
				}
				
			}
		}
	}

	validationForm = this.fb.group({
		titleRo: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
		titleEn: [''],
		titleFr: [''],
		titleDe: [''],
		descriptionRo: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
		descriptionEn: [''],
		descriptionFr: [''],
		descriptionDe: ['']
	})

	gdprvalidationForm = this.fb.group({
		gdprtitleRo: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
		gdprtitleEn: [''],
		gdprtitleFr: [''],
		gdprtitleDe: [''],
		gdprdescriptionRo: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
		gdprdescriptionEn: [''],
		gdprdescriptionFr: [''],
		gdprdescriptionDe: ['']
	})

	contactvalidationForm = this.fb.group({
		contacttitleRo: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
		contacttitleEn: [''],
		contacttitleFr: [''],
		contacttitleDe: [''],
		contactdescriptionRo: ['', [Validators.required, this.utilsService.NoWhitespaceValidator()]],
		contactdescriptionEn: [''],
		contactdescriptionFr: [''],
		contactdescriptionDe: ['']
	})

	getByUserContactDetails(email) {
		this.saveErrors = false
		this.utilsService.get('/admin/contactDetails/getByClientEmail?clientEmail=' + email)
			.subscribe(
				response => {
					this.contact = response;
					Object.assign(this.kioskListResource, this.kiosksList)
					for (let i = 0; i < this.kioskListResource.length; i++) {
						for (let j = 0; j < this.contact.kioskList.length; j++) {
							if (this.contact.kioskList[j].rid == this.kioskListResource[i].rid) {
								for (let k = 0; k < this.checkList.length; k++) {
									if (this.checkList[k].rid == this.kioskListResource[i].rid) {
										this.checkList[k].check = true;
										this.arrayToSend.push(this.checkList[k]);
									}
								}
							}
						}
					}
					console.log("----", this.checkList)
					if (this.text.errorCode == 11006) {
						this.text = new TermsOrGdprResource();
					}

				},
				error => this.errorMessage = <any>error);
	}

	getByUser(email, value) {
		this.saveErrors = false
		this.utilsService.get('/admin/text/termsOrGdpr/get?email=' + email + "&terms=" + value)
			.subscribe(
				response => {
					if (this.terms) {
						this.text = response;
						Object.assign(this.kioskListResource, this.kiosksList)
						for (let i = 0; i < this.kioskListResource.length; i++) {
							for (let j = 0; j < this.text.kioskResourceList.length; j++) {
								if (this.text.kioskResourceList[j].kiosk.rid == this.kioskListResource[i].rid) {
									for (let k = 0; k < this.checkList.length; k++) {
										if (this.checkList[k].kiosk.rid == this.kioskListResource[i].rid) {
											this.checkList[k].check = true;
											this.arrayToSend.push(this.checkList[k]);
										}
									}
								}
							}
						}
						console.log("----", this.checkList)
						if (this.text.errorCode == 11006) {
							this.text = new TermsOrGdprResource();
						}
					} else {
						this.gdpr = response
						Object.assign(this.kioskListResource, this.kiosksList)
						for (let i = 0; i < this.kioskListResource.length; i++) {
							for (let j = 0; j < this.gdpr.kioskResourceList.length; j++) {
								if (this.gdpr.kioskResourceList[j].kiosk.rid == this.kioskListResource[i].rid) {
									for (let k = 0; k < this.checkList.length; k++) {
										if (this.checkList[k].kiosk.rid == this.kioskListResource[i].rid) {
											this.checkList[k].check = true;
											this.arrayToSend.push(this.checkList[k]);
										}
									}
								}
							}
						}
						if (this.gdpr.errorCode == 11006) {
							this.gdpr = new TermsOrGdprResource();
						}
					}
				},
				error => this.errorMessage = <any>error);
	}

	edit() {
		this.saveErrors = true
		let errors = false;
		if (this.terms && !this.isContact) {
			if (!this.validationForm.valid) {
				forkJoin(
					this.translate.get('Mising fields'),
					this.translate.get('Please fill out the fields on all languages!')
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				});
				errors = true;
			}
			if (this.arrayToSend.length == 0) {
				forkJoin(
					this.translate.get('Mising fields'),
					this.translate.get('Please check at least 1 kiosk!')
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				});
				errors = true;
			}
			if (errors) {
				return;
			}
			this.text.userEmail = this.userEmail;
			this.text.terms = this.terms;
			this.text.kioskResourceList = this.arrayToSend;
			this.utilsService.add('/admin/text/termsOrGdpr/edit', this.text)
				.subscribe(
					response => {
						this.text = response;
						if (this.text.rid) {
							forkJoin(
								[this.translate.get('Success'),
								this.translate.get('Successfully edited!')]
							).subscribe((res) => {
								this._notificationService.create(res[0], res[1], 'success')
							});
						} else {
							forkJoin(
								[this.translate.get('Success'),
								this.translate.get('Successfully created!')]
							).subscribe((res) => {
								this._notificationService.create(res[0], res[1], 'success')
							});
						}
						window.scrollTo(500, 0);
						this.router.navigate(['/content-text']);
					},
					error => this.errorMessage = <any>error);

		} else if (!this.terms && !this.isContact) {
			if (!this.gdprvalidationForm.valid) {
				forkJoin(
					[this.translate.get('Mising fields'),
					this.translate.get('Please fill out the fields on all languages!')]
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				});
				errors = true;
			}
			if (this.arrayToSend.length == 0) {
				forkJoin(
					this.translate.get('Mising fields'),
					this.translate.get('Please check at least 1 kiosk!')
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				});
				errors = true;
			}
			if (errors) {
				return;
			}
			this.gdpr.userEmail = this.userEmail;
			this.gdpr.terms = this.terms;
			this.gdpr.kioskResourceList = this.arrayToSend;
			this.utilsService.add('/admin/text/termsOrGdpr/edit', this.gdpr)
				.subscribe(
					response => {
						this.gdpr = response;
						if (this.gdpr.rid) {
							forkJoin(
								[this.translate.get('Success'),
								this.translate.get('Successfully edited!')]
							).subscribe((res) => {
								this._notificationService.create(res[0], res[1], 'success')
							});
						} else {
							forkJoin(
								[this.translate.get('Success'),
								this.translate.get('Successfully created!')]
							).subscribe((res) => {
								this._notificationService.create(res[0], res[1], 'success')
							});
						}
						window.scrollTo(500, 0);
						this.router.navigate(['/content-text']);
					},
					error => this.errorMessage = <any>error);

		} else if (this.isContact) {
			if (!this.contactvalidationForm.valid) {
				forkJoin(
					[this.translate.get('Mising fields'),
					this.translate.get('Please fill out the fields on all languages!')]
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				});
				errors = true;
			}
			if (this.arrayToSend.length == 0) {
				forkJoin(
					this.translate.get('Mising fields'),
					this.translate.get('Please check at least 1 kiosk!')
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				});
				errors = true;
			}
			if (errors) {
				return;
			}
			this.contact.clientEmail = this.userEmail;
			//this.gdpr.terms = this.terms;
			console.log("-----", this.arrayToSend)
			this.contact.kioskList = this.arrayToSend;
			this.utilsService.add('/admin/contactDetails/addEditContactDetails', this.contact)
				.subscribe(
					response => {
						this.contact = response;
						if (this.contact.rid) {
							forkJoin(
								[this.translate.get('Success'),
								this.translate.get('Successfully edited!')]
							).subscribe((res) => {
								this._notificationService.create(res[0], res[1], 'success')
							});
						} else {
							forkJoin(
								[this.translate.get('Success'),
								this.translate.get('Successfully created!')]
							).subscribe((res) => {
								this._notificationService.create(res[0], res[1], 'success')
							});
						}
						window.scrollTo(500, 0);
						this.router.navigate(['/content-text']);
					},
					error => this.errorMessage = <any>error);
		}
	}


	delete() {
		if (this.isContact) {
			this.utilsService.get('/admin/contactDetails/deleteContactDetails/' + this.contact.rid)
				.subscribe(
					response => {
						this.router.navigate(['/content-text']);
					},
					error => this.errorMessage = <any>error);
		} else {
			this.utilsService.get('/admin/text/termsOrGdpr/delete?email=' + this.userEmail + "&terms=" + this.terms)
				.subscribe(
					response => {
						this.router.navigate(['/content-text']);
					},
					error => this.errorMessage = <any>error);
		}

	}


	deleteModal() {
		this.showDelete = true;
	}

	showResponsiveDetails(kioskId) {
		const width = window.innerWidth;
		if (width <= 1100) {
			for (let i = 0; i < this.kiosksList.list.length; i++) {
				if (this.kiosksList.list[i].rid == kioskId) {
					this.kiosksList.list[i].showDetailsOnResponsive = !this.kiosksList.list[i].showDetailsOnResponsive;
				}
				else {
					this.kiosksList.list[i].showDetailsOnResponsive = false;
				}
			}
		}
		else {
			return;
		}

	}

	changeListenerMainImage($event): void {
		console.log("FFEFFF: ", $event)
		var file: File = $event.target.files[0];
		var myReader: FileReader = new FileReader();
		var image = this.element.nativeElement.querySelector('#documentInput');
		if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
			(file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
			(file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
			(file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
			if (file.size < 1000000) {
				myReader.onloadend = (e: any) => {
					image.src = e.target.result;
					console.log("eddddddddddddddd", image);
					this.contact.imageString = e.target.result;
				}
				myReader.readAsDataURL(file);
			} else {
				forkJoin(
					this.translate.get('Image error'),
					this.translate.get('Image size is more than 1 mb!')
				).subscribe((res) => {
					this._notificationService.create(res[0], res[1], 'error')
				})
			}
		} else {
			forkJoin(
				this.translate.get('Image error'),
				this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')
			).subscribe((res) => {
				this._notificationService.create(res[0], res[1], 'error')
			})
		}
	}
}
